import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function createPracticeGroupForPro(
  name: string,
  description?: string,
) {
  const res = await fetchOrchidAPI(`/api/users/v1/practice_group/`, {
    method: "POST",
    body: JSON.stringify({
      name,
      description: description || "",
    }),
  });
  if (!res.ok) {
    const responseText = await res.text();
    console.error(getErrorDetail(responseText));
  }
  return res;
}
